import React from 'react';
import styled from '@emotion/styled';
import { useSelector } from 'react-redux';

import { ColorGreen, ColorSecondary, ColorWhite } from '../../../shared/GlobalStyles';

const ImageLightBoxContainer = styled('img')`
  border-radius: 24px;
  height: 100%;
  object-fit: contain;
  width: 100%;
`;

const ModalWrapper = styled('div')`
  display: flex;
  font-family: 'Nunito Sans';
  max-height: 80vh;
  width: 100%;
  .modal-button {
    align-items: center;
    background: ${ColorSecondary};
  }
`;

const WebcamContainer = styled('div')`
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  width: 100%;
  .text {
    font-size: 26px;
    font-weight: 300;
  }
  .capture-button {
    background-color: ${ColorGreen};
    color: ${ColorWhite};
    width: 180px;

    &:hover {
      opacity: .7;
    }
  }
`;

const ImageLightboxModal = () => {
  const image = useSelector((state) => state.journal.data.messageMediaUrl);
  return (
    <ModalWrapper>
      <WebcamContainer>
        <ImageLightBoxContainer
          src={image}
          alt='Journal entry image'
        />
      </WebcamContainer>
    </ModalWrapper>
  );
};

export default ImageLightboxModal;
